/**
 * Events of the public pages (landing, video, plans), sent through daevio's own script on daevio.com. The script is
 * loaded with `requireConsent`, so nothing leaves the browser before the visitor accepts measurement in the banner;
 * in builds without our own recording (local, previews) `window.daevio` is missing and this does nothing.
 */
export type SiteEvent =
  | { name: 'promo_video_played' }
  | { name: 'promo_video_progress'; pct: 25 | 50 | 75 | 100 }
  | { name: 'checkout_clicked'; product: 'pro' | 'enterprise' }
  | { name: 'real_visitors_page_view'; from: RealVisitorsSource }
  | { name: 'real_visitors_cta_clicked'; cta: 'add_script' | 'test' };

/** Where a visit to /real-visitors came from: the `?from=` the links carry, `direct` otherwise. */
export const REAL_VISITORS_SOURCES = ['landing', 'faq', 'footer', 'install', 'direct'] as const;
export type RealVisitorsSource = (typeof REAL_VISITORS_SOURCES)[number];

export function realVisitorsSource(value: string | null): RealVisitorsSource {
  return REAL_VISITORS_SOURCES.find((s) => s === value) ?? 'direct';
}

export function trackSite(event: SiteEvent): void {
  const { name, ...props } = event;
  try {
    const daevio = (window as unknown as { daevio?: (...args: unknown[]) => void }).daevio;
    if (typeof daevio === 'function') daevio('track', name, props);
  } catch {
    // measuring never breaks the page
  }
}
